// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3puiy","addWidgetButton":"Header_addWidgetButton__1R7bi","dashboardTabs":"Header_dashboardTabs__3a65Q","active":"Header_active__36NbE"};